<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4 class="text-center">
        <img style="width:100%;" src="@/assets/logo_flow_simulation_game_by_AGILEA.png" class="pb-3" />
        <v-card class="elevation-12">
          <v-form ref="loginForm" @submit.prevent="login">
            <v-toolbar dark color="primary">
              <v-spacer></v-spacer>
              <v-toolbar-title>Login</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
              <v-layout row="wrap">
                <v-flex xs4 class="pa-1" >
                  <v-text-field
                    @blur="toLowerCaser"
                    class="pt-4"
                    v-model="localAccount"
                    label="Account"
                    type="text"
                    outlined
                    :rules="[v => !!v || 'Requis']"
                    autocomplete="off"
                  ></v-text-field>
                </v-flex>
                <v-flex xs4 class="pa-1" >
                  <v-text-field
                    class="pt-4"
                    v-mask="'####'"
                    v-model="code"
                    label="Code"
                    type="text"
                    outlined
                    :rules="[v => !!v || 'Requis']"
                    autocomplete="off"
                  ></v-text-field>
                </v-flex>
                <v-flex xs4 class="pa-1" >
                  <v-text-field
                    class="pt-4"
                    v-model="playerName"
                    label="Nom/Name"
                    type="text"
                    outlined
                    :rules="[v => !!v || 'Requis']"
                    autocomplete="off"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions class="pt-0">
              <v-spacer></v-spacer>
              <v-btn color="primary" type="submit" :loading="userLoading">Join</v-btn>
              <v-btn color="secondary" @click="dialog = true">Rejoin</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialog" width="800">
      <v-card>
        <v-toolbar color="primary" dark dense>
          <v-spacer></v-spacer>
          <v-toolbar-title>Confirmation ?</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text class="text-xs-center">
          <v-row>
            <v-col cols="4">
              <v-text-field
                class="pt-4"
                v-model="localAccount"
                label="Account"
                type="text"
                outlined
                :rules="[v => !!v || 'Requis']"
                autocomplete="off"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                class="pt-4"
                v-mask="'####'"
                v-model="code"
                label="Code"
                type="text"
                outlined
                :rules="[v => !!v || 'Requis']"
                autocomplete="off"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                class="pt-4"
                v-mask="'####'"
                v-model="key"
                label="Key"
                type="password"
                outlined
                :rules="[v => !!v || 'Requis']"
                autocomplete="off"
              ></v-text-field>
            </v-col>
            <v-col cols="12" v-if="localGame">
              <v-row>
                <v-col
                  cols="6"
                  v-for="company in localGame.companies.filter((company) => company.assignable)"
                  :key="company._id"
                >
                  <v-card class="primary text-xs-center" style="color: white">
                    <v-card-text style="text-align: center; ">
                      <h4>{{company.name}}</h4>
                      <v-btn
                        color="secondary"
                        dark
                        @click="rejoinGame( company._id)"
                        :loading="userLoading"
                      >Select</v-btn>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="!localGame"
            color="primary"
            @click="askForReconnection"
            :loading="userLoading"
          >Ok</v-btn>
          <v-btn color="secondary" @click="dialog = false">Cancel</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { mask } from "vue-the-mask";

export default {

  name: "Login",

  directives: { mask },

  data() {
    return {
      dialog: false,
      localAccount: "",
      code: "",
      key: "",
      playerName: "",
      localGame: null,
      selectedCompany: null
    };
  },

  mounted() {
    this.checkIfAlreadyAuth()
    this.localAccount = this.account
  },

  methods: {

    toLowerCaser() {
      this.localAccount = this.localAccount.toLowerCase()
    },

    login() {
      this.localAccount = this.localAccount.toLowerCase()
      if (this.$refs.loginForm.validate()) {
        this.userLogin({
          code: this.code,
          playerName: this.playerName,
          account: this.localAccount
        });
      }
    },

    async askForReconnection() {
      let res = await this.askRejoin({
        code: this.code,
        key: this.key,
        account: this.localAccount
      });
      this.localGame = res || null;
    },

    async rejoinGame(company) {
      await this.rejoin({
        code: this.code,
        account: this.localAccount,
        company: company
      });
    },

    ...mapActions("user", {
      userLogin: "login",
      askRejoin: "askRejoin",
      rejoin: "rejoin",
      checkIfAlreadyAuth: "checkIfAlreadyAuth"
    })

  },
  computed: {
    ...mapGetters('interfaceSettings', {
      account: 'account'
    }),

    ...mapGetters('user', {
      userLoading: 'loading'
    })
  }
};
</script>
